export const manifest = {
  screens: {
    scr_cwz7ro: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_x5swwa: { name: "Shop Archive", route: "/shop", position: {"x":4360,"y":220} },
    scr_kqmhjn: { name: "Shop by Collection", route: "/collections", position: {"x":9960,"y":220} },
    scr_ssc6bg: { name: "Collection Story — Van Gogh Museum", route: "/collections/van-gogh-museum", position: {"x":7160,"y":220} },
    scr_hl83mg: { name: "Choose Your Story", route: "/stories", position: {"x":11360,"y":220} },
    scr_qrmak1: { name: "Story — Fynbos Botanicals", route: "/stories/fynbos-botanicals", position: {"x":8560,"y":220} },
    scr_owfs25: { name: "Product Page", route: "/product/karoo-ochre-dawn", position: {"x":2960,"y":220} },
    scr_qsmsa0: { name: "Size & Drink Guide", route: "/size-guide", position: {"x":160,"y":4180} },
    scr_b7prjy: { name: "Gifting", route: "/gifting", position: {"x":12760,"y":220} },
    scr_9klwu5: { name: "Corporate Branding", route: "/corporate-branding", position: {"x":7160,"y":6160} },
    scr_rhc4ka: { name: "About", route: "/about", position: {"x":160,"y":6160} },
    scr_ppdu3c: { name: "Stockists", route: "/stockists", position: {"x":2960,"y":6160} },
    scr_q1u8vz: { name: "Care", route: "/care", position: {"x":160,"y":8140} },
    scr_koj8i7: { name: "FAQs", route: "/faqs", position: {"x":1560,"y":8140} },
    scr_oq3s08: { name: "Contact", route: "/contact", position: {"x":4360,"y":6160} },
    scr_yrflbq: { name: "Shipping & Returns", route: "/shipping-returns", position: {"x":2960,"y":8140} },
    scr_6e16tt: { name: "Style Guide", route: "/style-guide", position: {"x":5760,"y":6160} },
    scr_c3e5tg: { name: "Type Sheet", route: "/type-sheet", position: {"x":1560,"y":10120} },
    scr_8f7j5v: { name: "Navigation Kit", route: "/navigation", position: {"x":160,"y":10120} },
    scr_0a8pdq: { name: "Social Icons", route: "/social-icons", position: {"x":2960,"y":10120} },
  },
  sections: {
    sec_zadb9r: { name: "Product Browsing Flow", x: 0, y: 0, width: 14120, height: 1180 },
    sec_iazhzx: { name: "Vibrant Product Browsing", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_03ext3: { name: "Cup Finder Quiz", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_f4ku4c: { name: "Information & Brand", x: 0, y: 5940, width: 8520, height: 1180 },
    sec_sawdhu: { name: "Help & Support", x: 0, y: 7920, width: 4320, height: 1180 },
    sec_wsv5qv: { name: "Design System Reference", x: 0, y: 9900, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_zadb9r", children: [
      { kind: "screen", id: "scr_cwz7ro" },
      { kind: "screen", id: "scr_owfs25" },
      { kind: "screen", id: "scr_x5swwa" },
      { kind: "screen", id: "scr_ssc6bg" },
      { kind: "screen", id: "scr_qrmak1" },
      { kind: "screen", id: "scr_kqmhjn" },
      { kind: "screen", id: "scr_hl83mg" },
      { kind: "screen", id: "scr_b7prjy" },
    ] },
    { kind: "section", id: "sec_iazhzx", children: [] },
    { kind: "section", id: "sec_03ext3", children: [
      { kind: "screen", id: "scr_qsmsa0" },
    ] },
    { kind: "section", id: "sec_f4ku4c", children: [
      { kind: "screen", id: "scr_rhc4ka" },
      { kind: "screen", id: "scr_ppdu3c" },
      { kind: "screen", id: "scr_oq3s08" },
      { kind: "screen", id: "scr_6e16tt" },
      { kind: "screen", id: "scr_9klwu5" },
    ] },
    { kind: "section", id: "sec_sawdhu", children: [
      { kind: "screen", id: "scr_q1u8vz" },
      { kind: "screen", id: "scr_koj8i7" },
      { kind: "screen", id: "scr_yrflbq" },
    ] },
    { kind: "section", id: "sec_wsv5qv", children: [
      { kind: "screen", id: "scr_8f7j5v" },
      { kind: "screen", id: "scr_c3e5tg" },
      { kind: "screen", id: "scr_0a8pdq" },
    ] },
  ],
}
